import { Box, Chip, ClickAwayListener, Divider, MenuItem, Popper, TextField } from '@mui/material';
import Paper from '@mui/material/Paper';
import { withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import TextPickerPopper from 'components/AdvFilter/TextPickerPopper';
import RenderSuggestion from 'components/AutoComplete/RenderSuggestion';
import { SpinnerIndicator } from 'components/CallServer';
import { RequestErrorReport } from 'components/CallServer/RequestErrorReport';
import DatePickerDialog from 'components/DatePickerDialog';
import { IGenericListSelectionProps } from 'components/GenericListSelection';
import AppResource from 'components/Translations/AppResources';
import Downshift, { ControllerStateAndHelpers, StateChangeOptions } from 'downshift';
import { Formaters } from 'lib/Formarters';
import LibUtils from 'lib/LibUtils';
import { GenericListItemDto } from 'models/ApiModels';
import * as moment from "moment";
import * as React from 'react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import GroupListSelection from 'views/Group/Components/GroupListSelection';
import BlockCodeSelection from 'views/System/Components/BlockCodeSelection';
import LocationSelection from 'views/System/Components/LocationSelection';
import TopicListSelection from 'views/Topic/Components/TopicListSelection';
import UserListSelection from 'views/User/Components/UserListSelection';
import UserRoleSelection from 'views/User/Components/UserRoleSelection';
import { Styles } from './Styles';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export enum AdvFilterPicker { BlockCode, Calendar, Group, Local, User, Text, Topic, Custom, Roles }

export const AutoCompleteKeyWord = "autocomplete";

export interface AdvFilterCommand {
    keyword: any;
    group?: number;
    optionGroup?: any;
    displayName?: string;
    canRepeat?: boolean;
    picker?: AdvFilterPicker;
    customPicker?: (props: IGenericListSelectionProps) => React.ReactElement;
}

export interface AdvFilterResult {
    keyword: any;
    value: any;
    text: string;
}

export function advFilterAddCommand(
    commands: AdvFilterCommand[],
    selectedCommands: AdvFilterResult[],
    cmdKeyWord: string,
    value: any,
    displayText: string = null): AdvFilterResult[] {

    const selectedItems = selectedCommands.slice(0);

    if (cmdKeyWord == AutoCompleteKeyWord) {

        var selected = selectedItems.find(p => p.keyword == AutoCompleteKeyWord);
        if (selected != null) {
            selected.text = displayText;
            selected.value = value;
        }
        else {
            selectedItems.push({ keyword: AutoCompleteKeyWord, text: displayText, value });
        }
    }
    else if (commands) {
        var cmd = commands.find(p => p.keyword == cmdKeyWord);
        if (cmd != null) {

            let text = cmd.displayName;

            if (cmd.picker != null) {
                // Calcula o texto do picker.

                if (displayText == null && value != null && cmd.picker == AdvFilterPicker.Calendar)
                    displayText = moment(value).format("L");

                text = cmd.displayName.replace("...", "") + ": " + (displayText || "");
            }

            selected = selectedItems.find(p => p.keyword == cmd.keyword);
            if (!cmd.canRepeat && selected != null) {
                selected.text = text;
                selected.value = value;
            }
            else {
                selectedItems.push({ keyword: cmd.keyword, text, value });
            }
        }
    }

    return selectedItems;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


interface IProps {
    id: string;
    container?: any;
    disabled?: boolean;
    label?: string;
    title?: string;
    placeHolderFocus?: string;
    placeHolder?: string;
    autoFocus?: boolean;
    overModal?: boolean;
    underlineColor?: "inherit" | "white" | "black";
    inputValue?: string;
    commands?: AdvFilterCommand[];
    selectedCommands: AdvFilterResult[];

    innerRef?: (ref: any) => void;
    onEscape?: () => void;
    onUpdateSelection: (inputValue: string, commands: AdvFilterResult[], pressedEnter: boolean) => void;

    autocomplete?: {
        tokenizeSelection: boolean;
        maxSuggestionCount?: number;
        onGetSuggestions: (searchText: string, offset: number, take: number) => Promise<AutoCompleteDataModel[]>;
    };
}

interface IState {
    inputValue: string;
    inputCommand: string;
    commandOpened: boolean;
    loadingCommands: boolean;
    commandItems: AdvFilterCommand[];
    picker: AdvFilterPicker;
    customPicker?: (props: IGenericListSelectionProps) => React.ReactElement;

    autoCompletedOpened: boolean;
    autoCompleteItems: Array<AutoCompleteDataModel>;
    loading: boolean;
    lastError: any;
    searchSkipRecords: number;
    suggestionLoadMore: boolean;

}

type Props = IProps & WithStyles<typeof Styles>;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const LoadMoreText: React.FC<{ count: number; }> = ({ count }) => {
    const { t } = useTranslation();
    return t("Common.Filter.LoadMoreNum", { count });
};

const EmptyRecordSet: React.FC<{}> = () => {
    const { t } = useTranslation();
    return <Box padding={1}><b>{t("Common.Filter.EmptyRecordset")}</b></Box>;
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


export class AdvFilterComponent extends React.PureComponent<Props, IState> {

    private inputRef: any;
    private inputRef2: any;
    private ref: any;
    private dref: any = React.createRef();
    private currentCmd: AdvFilterCommand;
    private escapeCount: number = 0;

    constructor(props: Props) {
        super(props);

        this.state = {
            inputValue: props.inputValue || "",
            inputCommand: '-',
            commandOpened: false,
            loadingCommands: false,
            commandItems: [],

            picker: null,
            customPicker: null,

            autoCompletedOpened: false,
            autoCompleteItems: [],
            loading: false,
            lastError: null,
            searchSkipRecords: 0,
            suggestionLoadMore: false
        };

    }

    static defaultProps: Partial<IProps> = {
        autoFocus: false,
        underlineColor: "inherit",
    };


    //#region HANDLERS

    private updateSelection(selectedItems: AdvFilterResult[], pressedEnter: boolean = false) {
        if (this.inputRef) {
            this.inputRef.focus();
        }
        if (this.props.onUpdateSelection) {
            this.props.onUpdateSelection(this.state.inputValue, selectedItems, pressedEnter);
        }
    }

    private handleDelete(item: AdvFilterResult) {
        const selectedItems = [...this.props.selectedCommands];
        const index = selectedItems.indexOf(item);
        selectedItems.splice(index, 1);
        this.setState({ commandOpened: false }, () => this.updateSelection(selectedItems));
    };

    private handleKeyDown(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
        //const { inputValue } = this.state;

        //if (event.keyCode == 13 && this.props.onEnter) {
        //    this.props.onEnter();
        //}
    }

    private handleKeyUp(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
        // IMPORTANTE: "nunca" trocar o evento para KeyDown, o que seria natural. 
        // Devido o modo de operação do downshift é preciso que ocorra uma mudanção no INPUT para que o hightlight index seja resetado.

        const { inputValue, autoCompletedOpened } = this.state;

        if (event.keyCode == 27) {

            if (!this.props.autocomplete) {
                if (this.props.onEscape)
                    this.props.onEscape();
                else if (++this.escapeCount > 1) {
                    this.escapeCount = 0;
                    this.setState({ inputValue: "" });
                }
            }
            else {
                // Em autocomplete, o ESC apenas reseta o input
                this.setState({ inputValue: "", autoCompletedOpened: false });
            }

        }
        else if (event.key == "/" && this.props.commands != null && this.props.commands.length > 0 && !autoCompletedOpened) {

            // Entra em modo de Comando.
            this.setState({
                commandOpened: true,
                loadingCommands: true,
                inputCommand: "",
            }, () => {
                this.inputRef2.focus();
                this.getCommands("");
            });

        }
        else if (event.keyCode == 13) {
            if (this.props.onUpdateSelection) {
                this.props.onUpdateSelection(inputValue, this.props.selectedCommands, true);
            }
            else if (this.props.autocomplete)
                this.setState({ inputValue: "" });
        }
    }

    private handleInputChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const v = (event.target as HTMLInputElement).value;

        // Entra modo de AutoComplete se o primeiro caracter digitado for '/'
        const autoCompletedOpened = this.props.autocomplete && v.length > 0 && v[0] != "/";

        this.setState({
            inputValue: v,
            autoCompletedOpened
        });
    }

    //#endregion


    //#region COMMAND 

    private handleKeyUpCmd(event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>, highlightedIndex: number) {
        const { autocomplete } = this.props;

        if ((event.key == "/" && !autocomplete) || event.keyCode == 27 || event.keyCode == 13) {
            event.preventDefault();

            const { commandOpened } = this.state;
            let { inputValue } = this.state;

            if (event.keyCode == 13 && this.state.commandItems.length > 0 && commandOpened && highlightedIndex == null) {
                // Seleciona primeiro item da lista de comandos (match parcial do nome do comando).
                this.handleDownshiftChange(this.state.commandItems[0]);
                inputValue = "";
            }
            else if (event.keyCode == 27 || event.keyCode == 13) {
                inputValue = inputValue.substr(0, this.state.inputValue.length - 1); // Remove último '/'
            }

            this.setState({
                commandOpened: false,
                inputCommand: "",
                inputValue
            }, () => {
                this.inputRef.focus();
            });
        }
    }

    private handleInputChangeCmd(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const v = (event.target as HTMLInputElement).value;
        this.setState({ inputCommand: v });
    };


    private internalAddCommand(cmdKeyWord: string, displayText: string, value: any) {

        var selectedItems = advFilterAddCommand(this.props.commands, this.props.selectedCommands, cmdKeyWord, value, displayText);

        let { inputValue } = this.state;
        inputValue = cmdKeyWord == AutoCompleteKeyWord
            ? ""
            : inputValue.substr(0, inputValue.length - 1); // Remove último '/'

        this.setState({
            autoCompletedOpened: false,
            commandOpened: false,
            picker: null,
            inputValue,
        }, () => this.updateSelection(selectedItems));
    }

    //#endregion


    //#region PICKERS

    private showPicker() {

        const { picker, customPicker } = this.state;

        switch (picker) {
            case AdvFilterPicker.Custom:

                return customPicker({
                    multi: false,
                    onSelect: (v) => {
                        this.handleSelectionListItem(v);
                    }
                });

            case AdvFilterPicker.Roles: return <UserRoleSelection multi={false} onSelect={(v) => { this.handleSelectionListItem(v); }} />;
            case AdvFilterPicker.User: return <UserListSelection multi={false} onSelect={(v) => { this.handleSelectionListItem(v); }} />;
            case AdvFilterPicker.Group: return <GroupListSelection multi={false} onSelect={(v) => { this.handleSelectionListItem(v); }} />;
            case AdvFilterPicker.Topic: return <TopicListSelection multi={false} onSelect={(v) => { this.handleSelectionListItem(v); }} />;
            case AdvFilterPicker.Local: return <LocationSelection multi={false} onSelect={(v) => { this.handleSelectionListItem(v); }} />;
            case AdvFilterPicker.BlockCode: return <BlockCodeSelection multi={false} onSelect={(v) => { this.handleSelectionListItem(v); }} />;
            case AdvFilterPicker.Calendar: return <DatePickerDialog onSelect={this.handleDatePicker} />;
            case AdvFilterPicker.Text: return <TextPickerPopper anchorEl={this.ref} onSelect={this.handleTextPicker} label={this.currentCmd.displayName} />;
        }
        return null;
    }

    private handleDatePicker = (dt: Date) => {
        this.setState({ picker: null });

        if (dt != null) {
            this.internalAddCommand(this.currentCmd.keyword, moment(dt).format("L"), dt);
            setTimeout(this.updateInputRefPosition, 100);
        }
    };

    private handleTextPicker = (text: string) => {
        this.setState({ picker: null });

        if (text != null) {
            this.internalAddCommand(this.currentCmd.keyword, LibUtils.truncateText(text, 15), text);
            setTimeout(this.updateInputRefPosition, 100);
        }
    };

    private handleSelectionListItem(v: GenericListItemDto[]) {
        this.setState({ picker: null });

        if (v != null) {
            this.internalAddCommand(this.currentCmd.keyword, v[0].name, v[0].id);
            setTimeout(this.updateInputRefPosition, 100);
        }
    }

    //#endregion


    //#region DownShift

    private updateInputRefPosition = () => {
        if (this.inputRef) this.inputRef.selectionStart = this.inputRef.selectionEnd = this.inputRef.length;
    };

    private handleDownshiftChange(cmd: AdvFilterCommand | AutoCompleteDataModel) {
        if (cmd) {
            if ('keyword' in cmd) {

                this.currentCmd = cmd as AdvFilterCommand;

                if (this.currentCmd.picker != null) {
                    this.setState({ picker: this.currentCmd.picker, customPicker: this.currentCmd.customPicker, commandOpened: false });
                }
                else {
                    this.internalAddCommand(this.currentCmd.keyword, null, null);
                }
            }
            else {
                const c = cmd as AutoCompleteDataModel;
                this.internalAddCommand(AutoCompleteKeyWord, c.label, c);
            }
        }
    }

    private handleDownshiftStateChange = (changes: StateChangeOptions<any>, downshiftState: ControllerStateAndHelpers<any>) => {

        if (downshiftState.isOpen) {

            if (this.state.autoCompletedOpened && changes.type == Downshift.stateChangeTypes.changeInput) {
                this.getSuggestions(downshiftState.inputValue, 0);
            }

            if (this.state.commandOpened && changes.type == Downshift.stateChangeTypes.changeInput) {
                this.getCommands(downshiftState.inputValue);
            }

            //if (this.state.commandOpened && changes.type == Downshift.stateChangeTypes.keyDownEnter) {
            //    this.internalAddCommand(this.state.commandItems[0].keyword, this.state.commandItems[0].displayName, null);
            //}
        }
    };

    private autocompleteTakeRecords() {
        const { autocomplete: { maxSuggestionCount } } = this.props;
        return maxSuggestionCount != null ? maxSuggestionCount : 10;
    }

    private getSuggestions(searchText: string, skipRecords: number) {
        const { autocomplete: { onGetSuggestions } } = this.props;
        const takeRecords = this.autocompleteTakeRecords();

        this.setState({ loading: true, lastError: null });

        onGetSuggestions(searchText, skipRecords, takeRecords + 1)
            .then((data) => {
                var records = data.slice(0, takeRecords);
                this.setState({
                    loading: false,
                    autoCompleteItems: (skipRecords == 0 ? records : [...this.state.autoCompleteItems, ...records]),
                    searchSkipRecords: (skipRecords + records.length),
                    suggestionLoadMore: (data.length > records.length)
                });

            })
            .catch((error) => {
                this.setState({ loading: false, suggestionLoadMore: false, lastError: error.canceled ? null : error });
            });
    }


    //#endregion


    private getCommands(searchText: string) {

        this.setState({ loadingCommands: true },
            () => {

                if (this.props.commands == null)
                    this.setState({ commandItems: [] });
                else {

                    var cmds = this.props.commands.slice(0);
                    this.props.selectedCommands.forEach((v) => {
                        const c = this.props.commands.find(p => p.keyword == v.keyword);
                        if (c && !c.canRepeat) {
                            cmds = cmds.filter(p => p.keyword != v.keyword);
                        }
                        if (c && c.optionGroup) {
                            cmds = cmds.filter(p => p.keyword == c.keyword || p.optionGroup != c.optionGroup);
                        }
                    });

                    // O match nos commandos são CASE e ACCENT INSENSITIVE.
                    var searchTextNorm = LibUtils.removeAccents(searchText).toLowerCase();

                    this.setState({
                        loadingCommands: false,
                        commandItems: cmds
                            .filter(p => searchText == "" || LibUtils.removeAccents(p.displayName).toLowerCase().indexOf(searchTextNorm) > -1)
                            .sort(p => p.group)
                    });
                }
            }
        );

    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    public addCommand(cmdKeyWord: string, displayText: string, value: any) {

        var selectedItems = advFilterAddCommand(this.props.commands, this.props.selectedCommands, cmdKeyWord, value, displayText);

        this.updateSelection(selectedItems);
    }

    public closeFilter() {
        this.setState({ inputValue: "", commandOpened: false, autoCompletedOpened: false });
    }


    public resetFilter() {
        this.setState({ inputValue: "", commandOpened: false, autoCompletedOpened: false }, () => this.updateSelection([]));
    }

    private handleOuterClick(event: MouseEvent | TouchEvent) {
        const target = event.target as HTMLElement;

        if (this.ref.contains(target)) {
            return;
        }

        this.setState({ commandOpened: false });

        if (this.props.onEscape) this.props.onEscape();
    }

    private checkForUpdateState(prevProps: Props) {
        if ((prevProps.inputValue || "") != (this.props.inputValue || "") && (this.props.inputValue || "") != this.state.inputValue) {
            this.setState({ inputValue: this.props.inputValue || "" });
        }
    }

    public componentDidUpdate(prevProps: Props) {
        this.checkForUpdateState(prevProps);
    }

    public componentDidMount() {
        if (this.props.innerRef) this.props.innerRef(this);
    }

    public render() {
        const { id, autoFocus, classes, container, disabled, placeHolder, placeHolderFocus, title, label, underlineColor } = this.props;
        const { inputValue, inputCommand, commandOpened, autoCompletedOpened, lastError, loading, loadingCommands } = this.state;
        let { selectedCommands } = this.props;
        const loadMoreId = id + '-loadmore';

        const iProps = {
            autoCapitalize: "off",
            autoComplete: "off",
            autoCorrect: "off",
            autoSave: "off",
            spellCheck: false,
        };

        if (this.props.autocomplete && !this.props.autocomplete.tokenizeSelection) {
            selectedCommands = selectedCommands.filter(p => p.keyword != AutoCompleteKeyWord);
        }

        const chips =
            selectedCommands.map(item => (
                <Chip
                    key={item.keyword}
                    tabIndex={-1}
                    label={item.text}
                    size="small"
                    color="info"
                    className={classes.autocompleteChip}
                    onDelete={() => this.handleDelete(item)}
                />
            ));

        const popperClasses = classNames({
            [classes.popperRoot]: true,
            [classes.popperRootOverModal]: this.props.overModal === true
        });


        return (
            <div id={id} className={classes.root}>
                <Downshift
                    id={id}
                    ref={(ref) => this.dref = ref}
                    inputValue={commandOpened ? inputCommand : inputValue}
                    onChange={(e) => this.handleDownshiftChange(e)}
                    onStateChange={this.handleDownshiftStateChange}
                    selectedItem={selectedCommands}
                    isOpen={commandOpened || autoCompletedOpened}
                >
                    {({
                        getInputProps,
                        getItemProps,
                        getMenuProps,
                        isOpen,
                        inputValue: inputValue2,
                        selectedItem: selectedItem2,
                        highlightedIndex,
                        setItemCount,
                    }) => {

                        // Ajusta ajustar a contagem de itens.
                        setItemCount(commandOpened
                            ? this.state.commandItems.length
                            : this.state.autoCompleteItems
                                ? this.state.autoCompleteItems.length
                                : 0);

                        return (
                            <div key={`adcontainer_${id}`} className={classes.container} >

                                {
                                    !commandOpened
                                        ? (
                                            <TextField
                                                fullWidth

                                                InputProps={
                                                    {
                                                        ...getInputProps(
                                                            {
                                                                onChange: (e) => this.handleInputChange(e),
                                                                onKeyDown: (e) => this.handleKeyDown(e),
                                                                onKeyUp: (e) => this.handleKeyUp(e),
                                                                onFocus: () => {
                                                                    if (this.inputRef && placeHolderFocus)
                                                                        (this.inputRef as HTMLInputElement).placeholder = placeHolderFocus;
                                                                },
                                                                onBlur: () => {
                                                                    if (this.inputRef && placeHolder)
                                                                        (this.inputRef as HTMLInputElement).placeholder = placeHolder;

                                                                    if (this.state.autoCompletedOpened)
                                                                        this.setState({ inputValue: "", commandOpened: false, autoCompletedOpened: false });
                                                                },
                                                                placeholder: placeHolder,
                                                                title: title,
                                                                autoFocus: autoFocus,
                                                                color: "primary",
                                                                ref: () => { }
                                                            }),
                                                        ...{
                                                            classes: {
                                                                root: classes.inputRoot,
                                                                input: classes.inputInput,
                                                                underline: underlineColor == "inherit"
                                                                    ? classes.inputUnderline
                                                                    : underlineColor == "white"
                                                                        ? classes.inputUnderlineWhite
                                                                        : classes.inputUnderlineBlack
                                                            },
                                                            startAdornment: chips,
                                                            size: "small"
                                                        }
                                                    }
                                                }
                                                disabled={disabled || false}
                                                inputProps={iProps}
                                                inputRef={(node) => { this.inputRef = node; }}
                                                label={label}
                                            />
                                        )
                                        : (
                                            <TextField
                                                fullWidth
                                                InputProps={
                                                    {
                                                        ...getInputProps(
                                                            {
                                                                onChange: (e) => this.handleInputChangeCmd(e),
                                                                onKeyUp: (e) => this.handleKeyUpCmd(e, highlightedIndex),
                                                                style: { backgroundColor: "#c0c0c0" },
                                                                color: "primary",
                                                                ref: () => { },
                                                            }),
                                                        ...{
                                                            classes: {
                                                                root: classes.inputRoot,
                                                                input: classes.inputInput,
                                                                underline: underlineColor == "inherit"
                                                                    ? classes.inputUnderline
                                                                    : underlineColor == "white"
                                                                        ? classes.inputUnderlineWhite
                                                                        : classes.inputUnderlineBlack
                                                            },
                                                            startAdornment: chips,
                                                            size: "small"
                                                        }
                                                    }
                                                }
                                                inputProps={iProps}
                                                inputRef={(node) => { this.inputRef2 = node; }}
                                            />
                                        )
                                }

                                <div ref={(ref) => this.ref = ref}>
                                    <div {...getMenuProps()} >
                                        {
                                            autoCompletedOpened &&
                                            <Popper
                                                disablePortal={false}
                                                open={true}
                                                anchorEl={this.ref}
                                                className={popperClasses}
                                                container={container ? document.getElementById(container) : document.body}
                                            >
                                                <Paper square={true} style={{ width: (this.ref ? this.ref.clientWidth : null), fontSize: "0.75rem" }} >
                                                    {
                                                        lastError
                                                            ? <RequestErrorReport error={lastError} />
                                                            : loading
                                                                ? <SpinnerIndicator />
                                                                : this.state.autoCompleteItems.length == 0
                                                                    ? <EmptyRecordSet />
                                                                    : this.state.autoCompleteItems.map((suggestion, index) =>
                                                                        <RenderSuggestion
                                                                            key={suggestion.key}
                                                                            suggestion={suggestion}
                                                                            index={index}
                                                                            currentInputValue={inputValue}
                                                                            itemProps={getItemProps({ item: suggestion })}
                                                                            highlightedIndex={suggestion.label == inputValue ? index : highlightedIndex}
                                                                            selectedItem={selectedItem2}
                                                                        />
                                                                    )
                                                    }

                                                    {
                                                        this.state.suggestionLoadMore
                                                            ? (
                                                                <>
                                                                    <Divider />
                                                                    <MenuItem
                                                                        {...getItemProps({ item: loadMoreId })}
                                                                        key={loadMoreId}
                                                                        className={classes.loadMore}
                                                                        onClick={() => { this.getSuggestions(this.state.inputValue, this.state.searchSkipRecords); }}
                                                                        component="div"
                                                                    >
                                                                        <LoadMoreText count={this.autocompleteTakeRecords()} />
                                                                    </MenuItem>
                                                                </>
                                                            )
                                                            : null
                                                    }

                                                </Paper>
                                            </Popper>
                                        }

                                        {
                                            commandOpened &&
                                            <ClickAwayListener onClickAway={(e) => this.handleOuterClick(e)}>
                                                <Popper
                                                    disablePortal={false}
                                                    open={true}
                                                    anchorEl={this.ref}
                                                    className={popperClasses}
                                                    container={container ? document.getElementById(container) : document.body}
                                                >
                                                    <Paper square={true} style={{ width: (this.ref ? this.ref.clientWidth : null), fontSize: "0.75rem" }} >
                                                        {
                                                            loadingCommands
                                                                ? <SpinnerIndicator />
                                                                : this.state.commandItems.length == 0
                                                                    ? <MenuItem><AppResource resource="Common.Filter.Adv.EmptyCommands" /></MenuItem>
                                                                    : this.state.commandItems.map((v, index, arr) => (
                                                                        <Fragment key={v.keyword}>

                                                                            {index > 0 && arr[index].group != arr[index - 1].group && <Divider />}

                                                                            <MenuItem
                                                                                {...getItemProps({ item: v })}
                                                                                selected={highlightedIndex == index}
                                                                                component="div"
                                                                                className={classes.popList}
                                                                            >
                                                                                <span dangerouslySetInnerHTML={{ __html: Formaters.htmlHighlightTerm(inputCommand, v.displayName) }}></span>
                                                                            </MenuItem>

                                                                        </Fragment>
                                                                    ))
                                                        }
                                                    </Paper>
                                                </Popper>
                                            </ClickAwayListener>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    }
                    }
                </Downshift>

                {this.state.picker != null && this.showPicker()}
            </div >
        );
    }
}

export default withStyles(Styles)(AdvFilterComponent);
